<template>
    <div class="ScheduleDetail" v-if="lang">
        <div class="table">
            <md-button class="md-icon-button md-raised button" @click.native="openDialog('dialog')">
                <md-icon>add</md-icon>
            </md-button>
            <md-dialog md-open-from="#custom" md-close-to="#custom" ref="dialog"
                :md-click-outside-to-close="close"
                :md-esc-to-close="close"
                class="dialog">
                <md-dialog-content>
                    <h3 class="dialog--title">{{ title }} {{ translate.pages.schedule.details.titleHours }}</h3>
                    <hr>
                    <div class="content-main">
                        <md-layout md-gutter class="modal-wrap">
                            <md-layout md-flex="100" class="container">
                                <label><strong>{{ translate.pages.schedule.details.fields.timeValidation }}</strong></label>
                            </md-layout>

                            <!-- DATEPICKER -->
                            <md-layout md-flex-small="100" md-flex="50" class="amolpicker container-date">
                                <label>{{ translate.pages.schedule.details.fields.startDate }}</label>
                                <md-icon class="icon-calendar">today</md-icon>
                                <date-picker :option="option" :limit="limit" class="picker" :date="startDate" v-model="currentSchedule.start_date"></date-picker>
                                <small class="small-error" v-if="errors.start_date.invalid">{{ errors.start_date.msg }}</small>
                            </md-layout>

                            <md-layout md-flex-small="100" md-flex="50" class="amolpicker container-date">
                                <label>{{ translate.pages.schedule.details.fields.endDate }}</label>
                                <md-icon class="icon-calendar">today</md-icon>
                                <date-picker :option="option" :limit="limit_end" class="picker" :date="endDate" v-model="currentSchedule.end_date"></date-picker>
                                <small class="small-error" v-if="errors.end_date.invalid">{{ errors.end_date.msg }}</small>
                            </md-layout>

                            <md-layout md-flex="100" class="container u-mar-top-075">
                                <label><strong>{{ translate.pages.schedule.details.fields.morningTime }}</strong></label>
                            </md-layout>

                            <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                                <label>{{ translate.pages.schedule.details.fields.startTime }} (00:00)</label>
                                <md-icon>query_builder</md-icon>
                                <vue-timepicker class="timer" v-model="time.start.morning" @change="updateTime($event, 'start_morning')"></vue-timepicker>
                                <small class="small-error" v-if="errors.start_morning.invalid">{{ errors.start_morning.msg }}</small>
                            </md-layout>
                            <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                                <label>{{ translate.pages.schedule.details.fields.endTime }} (00:00)</label>
                                <md-icon>query_builder</md-icon>
                                <vue-timepicker class="timer" v-model="time.end.morning" @change="updateTime($event, 'end_morning')"></vue-timepicker>
                                <small class="small-error" v-if="errors.end_morning.invalid">{{ errors.end_morning.msg }}</small>
                            </md-layout>
                            <md-layout md-flex="100" class="container checkbox-list">
                                <md-checkbox class="md-primary text--color" v-on:change="toggleMorningSchedule" v-model="currentSchedule.disableMorning" :checked="currentSchedule.disableMorning">Desactivar Mañana</md-checkbox>
                            </md-layout>
                            <md-layout md-flex="100" class="container">
                                <label><strong>{{ translate.pages.schedule.details.fields.afternoonTime }}</strong></label>
                            </md-layout>
                            <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                                <label>{{ translate.pages.schedule.details.fields.startTime }} (00:00)</label>
                                <md-icon>query_builder</md-icon>
                                <vue-timepicker class="timer" v-model="time.start.evening" @change="updateTime($event, 'start_evening')"></vue-timepicker>
                                <small class="small-error" v-if="errors.start_evening.invalid">{{ errors.start_evening.msg }}</small>
                            </md-layout>
                            <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                                <label>{{ translate.pages.schedule.details.fields.endTime }} (00:00)</label>
                                <md-icon>query_builder</md-icon>
                                <vue-timepicker class="timer" v-model="time.end.evening" @change="updateTime($event, 'end_evening')"></vue-timepicker>
                                <small class="small-error" v-if="errors.end_evening.invalid">{{ errors.end_evening.msg }}</small>
                            </md-layout>
                            <md-layout md-flex="100" class="container checkbox-list">
                                <md-checkbox class="md-primary text--color" v-on:change="toggleEveningSchedule" v-model="currentSchedule.disableEvening" :checked="currentSchedule.disableEvening">Desactivar Tarde</md-checkbox>
                            </md-layout>
                            <md-layout md-flex="100" class="container">
                                <label><strong>Días</strong></label>
                            </md-layout>
                            <md-layout md-flex="100" class="container checkbox-list">
                                <md-checkbox class="md-primary text--color" v-for="day in days" :key="day.id" @change="onChosen($event, day.id)" v-model="day.checked">{{ day.name }}</md-checkbox>
                            </md-layout>
                        </md-layout>
                    </div>
                </md-dialog-content>
                <md-dialog-actions class="modal--footer">
                    <md-button class="float-l md-primary md-size sm-size btn--cancel" @click.native="closeDialog('dialog')">{{ translate.pages.schedule.details.fields.cancel }}</md-button>
                    <md-button class="float-r md-primary md-size sm-size btn--blue" @click.native="closeDialog('dialog', true)" :disabled="process">{{ translate.pages.schedule.details.fields.accept }}</md-button>
                </md-dialog-actions>
            </md-dialog>
            <md-dialog md-open-from="#custom" md-close-to="#custom" ref="dialogTurn"
                :md-click-outside-to-close="close"
                :md-esc-to-close="close"
                class="dialog">
                <md-dialog-content>
                    <h3 class="dialog--title">{{ title }} {{ translate.pages.schedule.details.fields.horary }} - {{ currentTurn.day | formatDay }}</h3>
                    <hr>
                    <div class="content-main">
                        <md-layout md-gutter class="modal-wrap">
                            <md-layout  md-flex="100" class="container">
                                <label><strong>{{ translate.pages.schedule.details.fields.morningTime }}</strong></label>
                            </md-layout>
                            <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                                <label>{{ translate.pages.schedule.details.fields.startTime }} (00:00)</label>
                                <md-icon>query_builder</md-icon>
                                <vue-timepicker class="timer" v-model="currentTime.start.morning" @change="updateTime($event, 'start_morning', 1)"></vue-timepicker>
                                <small class="small-error" v-if="errors.start_morning.invalid">{{ errors.start_morning.msg }}</small>
                            </md-layout>
                            <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                                <label>{{ translate.pages.schedule.details.fields.endTime }} (00:00)</label>
                                <md-icon>query_builder</md-icon>
                                <vue-timepicker  class="timer" v-model="currentTime.end.morning" @change="updateTime($event, 'end_morning', 1)"></vue-timepicker>
                                <small class="small-error" v-if="errors.end_morning.invalid">{{ errors.end_morning.msg }}</small>
                            </md-layout>
                            <md-layout md-flex="100" class="container checkbox-list">
                                <md-checkbox class="md-primary text--color" v-on:change="toggleMorning" :value="currentTime.disableMorning" :checked="currentTime.disableMorning">Desactivar Mañana</md-checkbox>
                            </md-layout>
                            <md-layout md-flex="100" class="container">
                                <label><strong>{{ translate.pages.schedule.details.fields.afternoonTime }}</strong></label>
                            </md-layout>
                            <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                                <label>{{ translate.pages.schedule.details.fields.startTime }} (00:00)</label>
                                <md-icon>query_builder</md-icon>
                                <vue-timepicker class="timer" v-model="currentTime.start.evening" @change="updateTime($event, 'start_evening', 1)"></vue-timepicker>
                                <small class="small-error" v-if="errors.start_evening.invalid">{{ errors.start_evening.msg }}</small>
                            </md-layout>
                            <md-layout md-flex-small="100" md-flex="50" class="amoltimer">
                                <label>{{ translate.pages.schedule.details.fields.endTime }} (00:00)</label>
                                <md-icon>query_builder</md-icon>
                                <vue-timepicker class="timer" v-model="currentTime.end.evening" @change="updateTime($event, 'end_evening', 1)"></vue-timepicker>
                                <small class="small-error" v-if="errors.end_evening.invalid">{{ errors.end_evening.msg }}</small>
                            </md-layout>
                            <md-layout md-flex="100" class="container checkbox-list">
                                <md-checkbox class="md-primary text--color" v-on:change="toggleEvening" :value="currentTime.disableEvening" :checked="currentTime.disableEvening">Desactivar Tarde</md-checkbox>
                            </md-layout>
                        </md-layout>
                        <br>
                        <br>
                        <br>
                        <br>
                        <br>
                    </div>
                </md-dialog-content>
                <md-dialog-actions class="modal--footer">
                    <md-button class="float-l md-primary md-size sm-size btn--cancel" @click.native="closeDialog('dialogTurn')">{{ translate.pages.schedule.details.fields.cancel }}</md-button>
                    <md-button class="float-r md-primary btn--blue md-size sm-size" @click.native="closeDialog('dialogTurn', true)" :disabled="process">{{ translate.pages.schedule.details.fields.save }}</md-button>
                </md-dialog-actions>
            </md-dialog>
            <div class="table table--office table-mobile table--detail table-simple has-status">
            <md-table-card class="table--wrap">
                <md-table>
                    <md-table-header class="detail-head">
                        <md-table-row>
                            <md-table-cell class="name--cell">
                                <div class="img">
                                    <img :src="srcImage(office.path)">
                                </div>
                                <span class="name">{{ office.name }}</span>
                                <span class="subname visible-mobile">{{ office.street }} {{ office.number }}</span>
                            </md-table-cell>
                            <md-table-cell class="hidden-mobile">
                                <span>{{ office.street }} {{ office.number }}</span>
                            </md-table-cell>
                            <md-table-cell class="static-mobile">
                                <div class="enabled" :class="{ 'active' : office.active }">{{ office.active | formatEnabled }}</div>
                            </md-table-cell>
                        </md-table-row>
                    </md-table-header>
                    <md-table-body v-for="(schedule, rowIndex) in office.schedules" :key="rowIndex">
                        <md-table-row>
                            <md-table-cell class="schedule" colspan="2">
                                <span>
                                    <strong>{{ translate.pages.schedule.details.fields.horary }} -</strong>
                                    <span>{{ translate.pages.schedule.details.fields.valid }} {{ schedule.start_date | formatDate }}</span>
                                    <span>{{ translate.pages.schedule.details.fields.at }} {{ schedule.end_date | formatDate }}</span>
                                </span>
                            </md-table-cell>
                            <md-table-cell class="schedule actions-schedule">
                                <md-icon class="icon-edit raised" @click.native="openDialog('dialog', schedule, rowIndex)">edit</md-icon>
                                <md-icon class="icon-delete raised" @click.native="remove(schedule, rowIndex)">delete</md-icon>
                            </md-table-cell>
                        </md-table-row>
                        <md-table-row v-for="(turn, rowTurn) in schedule.turns" :key="rowTurn">
                            <md-table-cell>
                                <span class="day-schedule">{{ turn.day | formatDay }}</span>
                            </md-table-cell>
                            <md-table-cell>
                                <span>{{ turn | formatTurn }}</span>
                            </md-table-cell>
                            <md-table-cell class="actions-schedule">
                                <md-icon class="icon-edit raised" @click.native="openDialog('dialogTurn', rowIndex, turn, rowTurn)">edit</md-icon>
                                <md-icon class="icon-delete raised" @click.native="remove(schedule, rowIndex, turn, rowTurn)">delete</md-icon>
                            </md-table-cell>
                        </md-table-row>
                    </md-table-body>
                </md-table>
            </md-table-card>
            </div>
        </div>
    </div>
</template>
<script>
    const swal = require('sweetalert2');
    import moment from 'moment';
    import myDatepicker from 'vue-datepicker/vue-datepicker-es6.vue';
    import VueTimepicker from 'vue2-timepicker';
    import { doctor } from '../../../config/api.js';
    import { datepicker, options } from '../../../config/datepicker.js';

    export default {
        data() {
            return {
                process: false,
                old_time_morning: {},
                // for Vue 2.0
                startDate: { time: datepicker.now_format},
                endDate: { time: datepicker.now_format_end},
                time: {
                    start: { morning: {HH:'07', mm:'00'}, evening: {HH:'14', mm: '00'} },
                    end: { morning: {HH:'14', mm:'00'}, evening: {HH:'22', mm: '00'} },
                    disableMorning: false,
                    disableEvening: false
                },
                currentTime: {
                    start: { morning: {HH:'', mm:''}, evening: {HH:'', mm: ''} },
                    end: { morning: {HH:'', mm:''}, evening: {HH:'', mm: ''} },
                    disableMorning: false,
                    disableEvening: false
                },
                option: options,
                limit: [
                    {
                        type: 'fromto',
                        from: moment().subtract(1, "days"),
                        to: ''
                    }
                ],
                limit_end: [
                    {
                        type: 'fromto',
                        from: moment().subtract(1, "days"),
                        to: ''
                    }
                ],
                //
                title: 'Agregar',
                office: {},
                currentSchedule: {
                    'start_date': '',
                    'end_date': '',
                    'start_morning': '',
                    'end_morning': '',
                    'start_evening': '',
                    'end_evening': ''
                },
                currentIndex: -1,
                currentTurn: {},
                currentIndexTurn: -1,
                isUpdate: false,
                isUpdateTurn: false,
                days: [
                    {'id':0, 'name' : 'Lunes', checked: false},
                    {'id':1, 'name' : 'Martes', checked: false},
                    {'id':2, 'name' : 'Miércoles', checked: false},
                    {'id':3, 'name' : 'Jueves', checked: false},
                    {'id':4, 'name' : 'Viernes', checked: false},
                    {'id':5, 'name' : 'Sábado', checked: false},
                    {'id':6, 'name' : 'Domingo', checked: false}
                ],
                checkedDays: [],
                errors: {
                    'start_date': {
                        'invalid': false,
                        'msg': ''
                    },
                    'end_date': {
                        'invalid': false,
                        'msg': ''
                    },
                    'start_morning': {
                        'invalid': false,
                        'msg': ''
                    },
                    'end_morning': {
                        'invalid': false,
                        'msg': ''
                    },
                    'start_evening': {
                        'invalid': false,
                        'msg': ''
                    },
                    'end_evening': {
                        'invalid': false,
                        'msg': ''
                    },
                    'response': {
                        'invalid': false,
                        'msg': ''
                    }
                },
                close: false,
                disabled: false,
            }
        },
        created() {
            let officeId = this.$route.params.officeId;
            let url = doctor.api.offices + '/' + officeId;
            let parent = this.$auth.getParent();
            if(parent)
            {
                url += '?parent=' + parent;
            }
            // Get offices
            this.$http.get(url,{
                        headers: {
                            Authorization : 'Bearer '+ this.$auth.getToken(),
                        }
                }).then(response => {
                    let data = response.data.data;
                    this.office = data;
                }).catch(error => {
                    if(error.response.status === 404){
                        swal('Consultas', error.response.data.msg, 'warning')
                            .then( () => {
                                this.$router.push({'name': 'Schedule'});
                            });
                    }else{
                        console.log("obj");
                    }
                    //alert("No se pudo cargar las comunidades");
                });
        },
        computed: {
            // Get Language
            translate(){
                return this.$store.getters.language.app[this.lang].prestador;
            },
            // Get Lang
            lang(){
                return this.$store.getters.language.lang;
            }
        },
        methods: {
            // Toggle Morning
            toggleMorning(v, e) {
                console.log(e, "dsds")
                if(v){

                    this.currentTurn.start_morning = this.currentTurn.end_morning
                    this.currentTurn.end_morning = this.currentTurn.start_evening;


                } else {
                    this.currentTurn.start_morning = "08:00";
                    this.currentTurn.end_morning = "14:00";
                }
                this.currentTime = this.getTurnTime(this.currentTurn);
            },
            toggleEvening(v, e) {
                if(v){
                    this.currentTurn.start_evening = this.currentTurn.end_morning
                    this.currentTurn.end_evening = this.currentTurn.end_morning;

                } else {
                    this.currentTurn.start_evening = "14:00"
                    this.currentTurn.end_evening = "22:00";
                }
                this.currentTime = this.getTurnTime(this.currentTurn);
            },
             toggleMorningSchedule(v, e) {
                console.log(e, "dsds")
                if(v){

                    this.currentSchedule.start_morning = this.currentSchedule.end_morning
                    this.currentSchedule.end_morning = this.currentSchedule.start_evening;


                } else {
                    this.currentSchedule.start_morning = "08:00";
                    this.currentSchedule.end_morning = "14:00";

                }
                this.time = this.getTurnTime(this.currentSchedule);
            },
            toggleEveningSchedule(v, e) {
                if(v){
                    this.currentSchedule.start_evening = this.currentSchedule.end_morning
                    this.currentSchedule.end_evening = this.currentSchedule.end_morning;

                } else {
                    this.currentSchedule.start_evening = "14:00"
                    this.currentSchedule.end_evening = "22:00";
                }
                this.time = this.getTurnTime(this.currentSchedule);
            },
            // Get path office
            srcImage(path){
                if(path){
                    return path;
                }
                return 'https://api.agendaenlinea.cl/image/default_avatar.png';
            },
            // Open Modal
            openDialog(ref, row, rowIndex, rowTurn){
                if(typeof rowIndex != "undefined" || rowIndex >= 0)
                {
                    this.title = 'Editar';
                    if(ref == 'dialogTurn'){
                        this.currentIndex = row;
                        this.currentTurn = JSON.parse(JSON.stringify(rowIndex));

                        this.currentIndexTurn = rowTurn;
                        if(!this.currentTurn.start_morning || this.currentTurn.start_morning.indexOf(':') < 0)
                        {
                            this.currentTurn.start_morning = ':';
                        }
                        if(!this.currentTurn.end_morning || this.currentTurn.end_morning.indexOf(':') < 0)
                        {
                            this.currentTurn.end_morning = ':';
                        }
                        if(!this.currentTurn.start_evening || this.currentTurn.start_evening.indexOf(':') < 0)
                        {
                            this.currentTurn.start_evening = ':';
                        }
                        if(!this.currentTurn.end_evening || this.currentTurn.end_evening.indexOf(':') < 0)
                        {
                            this.currentTurn.end_evening = ':';
                        }
                        this.currentTime = this.getTurnTime(this.currentTurn);
                        this.currentTime.disableMorning = this.currentTurn.start_morning == this.currentTurn.end_morning &&  this.currentTurn.end_morning == this.currentTurn.start_evening;
                        this.currentTime.disableEvening = this.currentTurn.start_evening == this.currentTurn.end_morning && this.currentTurn.end_morning == this.currentTurn.end_evening;
                        console.log(this.currentTime)
                        this.isUpdateTurn = true;
                    } else {
                        this.currentSchedule = JSON.parse(JSON.stringify(row));
                        this.startDate.time = moment(this.currentSchedule.start_date).format('DD/MM/YYYY');
                        this.endDate.time = moment(this.currentSchedule.end_date).format('DD/MM/YYYY');
                        this.currentSchedule.start_morning = "08:00";
                        this.currentSchedule.end_morning = "14:00";
                        this.currentSchedule.start_evening = "14:00"
                        this.currentSchedule.end_evening = "22:00";
                        this.currentSchedule.disableMorning = false;
                        this.currentSchedule.disableEvening = false;

                        this.currentIndex = rowIndex;
                        this.currentSchedule.turns.forEach((turn,index) => {
                            if(turn.start_morning || turn.start_evening)
                            {
                                this.days[index].checked = true;
                                this.checkedDays.push(index);
                            }
                        });
                        this.isUpdate = true;
                        console.log(this.currentSchedule)
                    }
                }else{
                    this.title = 'Agregar';
                    this.currentSchedule.start_morning = "08:00";
                        this.currentSchedule.end_morning = "14:00";
                        this.currentSchedule.start_evening = "14:00"
                        this.currentSchedule.end_evening = "22:00";
                        this.currentSchedule.end_date = moment().add(1, "years").format('DD/MM/YYYY');
                        this.endDate.time = moment().add(1, "years").format('DD/MM/YYYY');
                }
                this.$refs[ref].open();
            },
            // Get Turn time
            getTurnTime(turn){
                var start_morning = turn.start_morning.split(":");
                var end_morning =  turn.end_morning.split(":");
                var start_evening =  turn.start_evening.split(":");
                var end_evening =  turn.end_evening.split(":");
                return {
                    start: { morning: {HH: start_morning[0], mm:start_morning[1]}, evening: {HH:start_evening[0], mm:start_evening[1]} },
                    end: { morning: {HH:end_morning[0], mm:end_morning[1]}, evening: {HH:end_evening[0], mm:end_evening[1]} }
                }
            },
            // Close Modal
            closeDialog(ref, save) {
                if(save)
                {
                    if(this.isUpdate){
                        this.update(ref);
                    }else{
                        if(this.isUpdateTurn){
                            this.updateTurn(ref);
                        }else{
                            this.save(ref);
                        }
                    }
                }else{
                    this.currentIndex = -1;
                    this.checkedDays = [];
                    this.days.forEach( day  => {
                        day.checked = false;
                    });
                    this.currentSchedule.start_date = '';
                    this.currentSchedule.end_date = '';
                    this.startDate.time = datepicker.now_format;
                    this.endDate.time = datepicker.now_format;
                    for(let item in this.errors)
                    {
                        for(let key in this.errors[item])
                        {
                            if(key == 'invalid')
                            {
                                this.errors[item][key] = false;
                            }
                        }
                    }
                    this.isUpdate = false;
                    this.isUpdateTurn = false;
                    this.$refs[ref].close();
                }
            },
            // On Chose by day
            onChosen(event, day_id){
                if(event){
                    this.days.find( day  => {
                        if (day.id == day_id){
                            day.checked = true;
                        }
                    });
                    this.checkedDays.push(day_id);
                }else{
                    this.days.find( day  => {
                        if (day.id == day_id){
                            day.checked = false;
                        }
                    });
                    let pos = this.checkedDays.indexOf(day_id);
                    this.checkedDays.splice(pos, 1);
                }
            },
            // Store schedule
            save(ref){
                if(this.validateData())
                {
                    this.currentSchedule.days = this.checkedDays;
                    this.currentSchedule.office_id = this.office.id;
                    let url = doctor.api.schedules;
                    let parent = this.$auth.getParent();
                    if(parent)
                    {
                        url += '?parent=' + parent;
                    }
                    this.process = true;
                    this.$http.post(url, this.currentSchedule, {
                            headers: {
                                Authorization : 'Bearer '+ this.$auth.getToken(),
                            }
                    }).then(response => {
                        this.process = false;
                        this.office.schedules.push(response.data.data);
                        this.checkedDays = [];
                        this.currentIndex = -1;
                        this.days.forEach( day  => {
                            day.checked = false;
                        });
                        this.currentSchedule.start_date = '';
                        this.currentSchedule.end_date = '';
                        this.$refs[ref].close();
                        swal('', response.data.msg, 'success');
                    }).catch(error => {
                        this.process = false;
                        if(error.response.status === 422){
                            let data = error.response.data;
                            for(let index in data)
                            {
                                this.errors[index].invalid = true;
                                let messages = '';
                                data[index].forEach( item => messages += item + ' ');
                                this.errors[index].msg = messages;
                            }
                            this.errors.response.invalid = false;
                        }else if(error.response.status === 404){
                            this.errors.response.invalid = true;
                            this.errors.response.msg = error.response.data.message;
                        }
                    });
                }
            },
            // Update schedule
            update(ref) {
                if(this.validateData())
                {
                    this.currentSchedule.days = this.checkedDays;
                    this.currentSchedule.office_id = this.office.id;
                    delete this.currentSchedule.turns;
                    let url = doctor.api.schedules  + '/' + this.currentSchedule.id;
                    let parent = this.$auth.getParent();
                    if(parent)
                    {
                        url += '?parent=' + parent;
                    }
                    this.process = true;
                    this.$http.put(url, this.currentSchedule, {
                            headers: {
                                Authorization : 'Bearer '+ this.$auth.getToken(),
                            }
                    }).then(response => {
                        this.process = false;
                        this.office.schedules[this.currentIndex] = response.data.data;
                        this.currentSchedule = {};
                        this.checkedDays = [];
                        this.currentIndex = -1;
                        this.days.forEach( day  => {
                            day.checked = false;
                        });
                        this.currentSchedule.start_date = '';
                        this.currentSchedule.end_date = '';
                        this.$refs[ref].close();
                        this.isUpdate = false;
                        swal('', response.data.msg, 'success');
                    }).catch(error => {
                        this.process = false;
                        if(error.response.status === 422){
                            let data = error.response.data;
                            for(let index in data)
                            {
                                this.errors[index].invalid = true;
                                let messages = '';
                                data[index].forEach( item => messages += item + ' ');
                                this.errors[index].msg = messages;
                            }
                            this.errors.response.invalid = false;
                        }else if(error.response.status === 404){
                            this.errors.response.invalid = true;
                            this.errors.response.msg = error.response.data.message;
                        }
                    });
                }
            },
            // Update turn
            updateTurn(ref) {
                if(this.validateDataTurn())
                {
                    let url = doctor.api.turns  + '/' + this.currentTurn.id;
                    let parent = this.$auth.getParent();
                    if(parent)
                    {
                        url += '?parent=' + parent;
                    }
                    this.process = true;
                    this.$http.put(url, this.currentTurn, {
                            headers: {
                                Authorization : 'Bearer '+ this.$auth.getToken(),
                            }
                    }).then(response => {
                        this.process = false;
                        this.office.schedules[this.currentIndex].turns[this.currentIndexTurn] = response.data.data;
                        this.currentTurn = {};
                        this.currentIndex = -1;
                        this.currentIndexTurn = -1;
                        this.$refs[ref].close();
                        swal('', response.data.msg, 'success');
                    }).catch(error => {
                        this.process = false;
                        if(error.response.status === 422){
                            let data = error.response.data;
                            for(let index in data)
                            {
                                this.errors[index].invalid = true;
                                let messages = '';
                                data[index].forEach( item => messages += item + ' ');
                                this.errors[index].msg = messages;
                            }
                            this.errors.response.invalid = false;
                        }else if(error.response.status === 404){
                            this.errors.response.invalid = true;
                            this.errors.response.msg = error.response.data.message;
                        }
                    });
                }
            },
            // Remove turn
            remove(row, rowIndex, rowTurn, rowIndexTurn){
                let url;
                if(rowTurn)
                {
                    url = doctor.api.turns;
                    url += '/' + rowTurn.id;
                }else{
                    url = doctor.api.schedules;
                    url += '/' + row.id;
                }
                let parent = this.$auth.getParent();
                if(parent)
                {
                    url += '?parent=' + parent;
                }
                swal('', '¿Esta seguro de eliminar el horario?', 'warning')
                    .then( () => {
                        this.$http.delete(url,{
                                    headers: {
                                        Authorization : 'Bearer '+ this.$auth.getToken(),
                                    }
                            }).then(response => {
                                swal('', response.data.msg, 'success')
                                    .then( () => {
                                        if(rowTurn){
                                            this.office.schedules[rowIndex].turns[rowIndexTurn] = response.data.data;
                                        }else{
                                            this.office.schedules.splice(rowIndex, 1);
                                        }
                                    }, (dismiss) => {
                                        if(rowTurn)
                                        {
                                            this.office.schedules[rowIndex].turns[rowIndexTurn] = response.data.data;
                                        }else{
                                            this.office.schedules.splice(rowIndex, 1);
                                        }
                                    });
                            }).catch(error => {
                                console.log(error);
                            });
                    }, (dismiss) => {
                        //console.log(dismiss);
                    });
            },
            // Validate Data form
            validateData() {
                let error = false;
                this.currentSchedule.start_date = this.startDate.time;
                this.currentSchedule.end_date = this.endDate.time;
                let rangeTimes = ['start_morning', 'start_evening', 'end_morning', 'end_evening'];
                rangeTimes.forEach(target => {
                    let arr = target.split('_');
                    let _time = '';
                    if(this.time[arr[0]][arr[1]].HH == "" || this.time[arr[0]][arr[1]].mm == ""){
                        _time = '';
                    }else{
                        _time = this.time[arr[0]][arr[1]].HH + ':' + this.time[arr[0]][arr[1]].mm;
                    }
                    this.currentSchedule[target] = _time;
                });
                // validate one
                if(this.currentSchedule.start_date.length == 0)
                {
                    this.errors.start_date.invalid = true;
                    this.errors.start_date.msg = "Debe ingresar la Fecha de Inicio.";
                    error = true;
                }else{
                    this.errors.start_date.invalid = false;
                    this.errors.start_date.msg = "";
                }
                if(this.currentSchedule.end_date.length == 0)
                {
                    this.errors.end_date.invalid = true;
                    this.errors.end_date.msg = "Debe ingresar la Fecha de Fin.";
                    error = true;
                }else{
                    this.errors.end_date.invalid = false;
                    this.errors.end_date.msg = "";
                }
                if(this.currentSchedule.start_morning.length > 0 && (!this.currentSchedule.end_morning || this.currentSchedule.end_morning.length == 0) )
                {
                    this.errors.end_morning.invalid = true;
                    this.errors.end_morning.msg = "Debe ingresar el end_morning.";
                    error = true;
                }else{
                    this.errors.end_morning.invalid = false;
                    this.errors.end_morning.msg = "";
                }
                if(this.currentSchedule.start_evening.length > 0 && (!this.currentSchedule.end_evening || this.currentSchedule.end_evening.length == 0))
                {
                    this.errors.end_evening.invalid = true;
                    this.errors.end_evening.msg = "Debe ingresar el end_evening.";
                    error = true;
                }else{
                    this.errors.end_evening.invalid = false;
                    this.errors.end_evening.msg = "";
                }
                if(error){
                    return false;
                }
                return true;
            },
            // Validate data turn
            validateDataTurn() {
                let error = false;
                let rangeTimes = ['start_morning', 'start_evening', 'end_morning', 'end_evening'];
                console.log("validateTurn");
                rangeTimes.forEach(target => {
                    let arr = target.split('_');
                    let _time = '';
                    if(this.currentTime[arr[0]][arr[1]].HH == "" || this.currentTime[arr[0]][arr[1]].mm == ""){
                        _time = '';
                    }else{
                        _time = this.currentTime[arr[0]][arr[1]].HH + ':' + this.currentTime[arr[0]][arr[1]].mm;
                    }
                    this.currentTurn[target] = _time;
                });
                if(this.currentTurn.start_morning.length > 0 && (!this.currentTurn.end_morning || this.currentTurn.end_morning.length == 0) )
                {
                    this.errors.end_morning.invalid = true;
                    this.errors.end_morning.msg = "Debe ingresar el Fin de Mañana.";
                    error = true;
                }else{
                    this.errors.end_morning.invalid = false;
                    this.errors.end_morning.msg = "";
                }
                if(this.currentTurn.start_evening.length > 0 && (!this.currentTurn.end_evening || this.currentTurn.end_evening.length == 0))
                {
                    this.errors.end_evening.invalid = true;
                    this.errors.end_evening.msg = "Debe ingresar el Fin de Tarde.";
                    error = true;
                }else{
                    this.errors.end_evening.invalid = false;
                    this.errors.end_evening.msg = "";
                }
                if(error){
                    console.log("validateTurn Error");
                    console.log(this.errors);
                    return false;
                }
                return true;
            },
            // Update time
            updateTime($event, target, type=0){
                if(type==0){
                    this.currentSchedule[target] = $event.data.HH + ':' + $event.data.mm;
                    this.currentSchedule.disableMorning = this.currentSchedule.start_morning == this.currentSchedule.end_morning &&  this.currentSchedule.end_morning == this.currentSchedule.start_evening;
                    this.currentSchedule.disableEvening = this.currentSchedule.start_evening == this.currentSchedule.end_morning && this.currentSchedule.end_morning == this.currentSchedule.end_evening;
                } else {
                    this.currentTurn[target] = $event.data.HH + ':' + $event.data.mm;
                    console.log("actualizando:", target, this.currentTurn[target])
                    this.currentTime.disableMorning = this.currentTurn.start_morning == this.currentTurn.end_morning &&  this.currentTurn.end_morning == this.currentTurn.start_evening;
                    this.currentTime.disableEvening = this.currentTurn.start_evening == this.currentTurn.end_morning && this.currentTurn.end_morning == this.currentTurn.end_evening;
                }
            }
        },
        components: {
            'date-picker': myDatepicker,
            VueTimepicker
        },
        watch: {
            'currentTurn': function(){
                console.log("cambio bitch")


            }
        }
    }
</script>
<style lang="stylus" scoped>
    @import '../../../assets/styles/variables/color.styl'
    .ScheduleDetail
        padding 54px 12px 20px
        position relative
        .button
            background-color color_main
            color white
            position absolute
            right 1em
            top 0.5em
            z-index 2
            &:hover
                background-color color_main !important
                color white
        .table
            .enabled
                border 1px solid color_form_placeholder
                border-radius 30px
                color color_form_placeholder
                margin 0 auto
                padding 3px 4px
                text-align center
                margin-right 16px
                width 110px
                &.active
                    border 1px solid color_confirm
                    color color_confirm
            .schedule
                background #ebecf0
            .icon-edit
                color color_notifications
                cursor pointer
                font-size 22px
            .icon-delete
                color color_error
                cursor pointer
                font-size 22px
    .content-main
        .container
            padding 0.25em 1em
    .small-error
        color #ff5722
    .w100
        width 100%
    .w90
        width 90%
    .icon-calendar
        width 10%
        margin-bottom .4em
    .icon-time
        margin-bottom 0.75em
        width 10%
    .u-mar-top-075
        margin-top .75em
    @import '../../../assets/styles/responsive.styl'
    @media(max-width: 390px)
        .sm-size
            padding 0 1em!important
</style>
<style>
    .text--color {
        color: black !important;
    }
    .btn--cancel {
        color: #ff0000b3 !important;
    }
</style>


// WEBPACK FOOTER //
// Detail.vue?0a1974bf